import SearchBusinesses from "./SearchBusinesses";

export default SearchBusinesses;
